import Text from './text'

export default function File(input) {
  let extensions = input.onlyAllowExtensions
  let field = Text(input)

  let validations = [`isFile:${input.identifier}`]
  let errorMessages = null
  if (extensions) {
    validations = [`hasExtensions:["${extensions.join('", "')}"]`]
    errorMessages = [
      {
        key: 'bus-client.errors.incorrectFileType',
        param: 'type',
        value: `${extensions.join(', ')}`
      }
    ]
  }

  return {
    ...field,
    value: field.value,
    validations,
    errorMessages
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/helpers/file.js